import request from "@/utils/request"
// 主营品牌
// 获取国别
export function GetContry(data) {
	return request({
		url: "/api/Merchant/GetContry",
		method: "post",
		data
	})
}
// 获取品牌

export function GetContryBrand(data) {
	return request({
		url: "/api/Merchant/GetContryBrand",
		method: "post",
		data
	})
}

// 获取车系

export function GetContryBrandFamily(data) {
	return request({
		url: "/api/Merchant/GetContryBrandFamily",
		method: "post",
		data
	})
}
// 获取主营业务

export function GetMainBusiness(data) {
	return request({
		url: "/api/Merchant/GetMainBusiness",
		method: "post",
		data
	})
}
// 保存主营品牌

export function SaveMainBusiness(data) {
	return request({
		url: "/api/Merchant/SaveMainBusiness",
		method: "post",
		data
	})
}
// 删除主营业务

export function DelMainBusiness(data) {
	return request({
		url: "/api/Merchant/DelMainBusiness",
		method: "post",
		data
	})
}
// 配件统计名称
export function GetStatisticsName(data) {
	return request({
		url: "/api/Merchant/GetStatisticsName",
		method: "post",
		data
	})
}

// 配件配件名称
export function GetAutoPartsName(data) {
	return request({
		url: "/api/Merchant/GetAutoPartsName",
		method: "post",
		data
	})
}